import React from 'react';
import PropTypes from 'prop-types';
import { Button, CircularProgress } from '@material-ui/core';
import { CheckCircle, Error as ErrorIcon } from '@material-ui/icons';
import clsx from 'clsx';
import { useLocalizedMessage } from '../../../../util/useLocalizedMessage';
import styles from './Diagnostics.module.scss';

function BundleBuildBlock({
  bundleRebuildStatus,
  bundleRebuildError,
  onRebuildBundle,
  onBuildAndPromote,
}) {
  const localizeMessage = useLocalizedMessage();

  const isBuilding = bundleRebuildStatus === 'queued' || bundleRebuildStatus === 'running';
  const isSuccess = bundleRebuildStatus === 'success';
  const isError = bundleRebuildStatus === 'failed';

  return (
    <div className={styles.bundleBuildBlock} data-testid="diag-bundle-build">
      <div className={styles.bundleBuildActions}>
        <Button
          size="small"
          variant="outlined"
          onClick={onRebuildBundle}
          disabled={isBuilding}
          data-testid="diag-rebuild-preview-btn"
        >
          {localizeMessage(isBuilding ? 'operator.diag.preview.rebuilding' : 'operator.diag.preview.rebuild')}
        </Button>

        <Button
          size="small"
          variant="outlined"
          onClick={onBuildAndPromote}
          disabled={isBuilding}
          data-testid="diag-build-promote-btn"
        >
          {localizeMessage('operator.diag.bundle.build_and_promote')}
        </Button>
      </div>

      {isSuccess && (
        <div className={clsx(styles.bundleBuildStatus, styles.success)} data-testid="diag-bundle-success">
          <CheckCircle className={styles.iconSize} />
          <span>{localizeMessage('operator.diag.bundle.success')}</span>
        </div>
      )}

      {isError && bundleRebuildError && (
        <div className={clsx(styles.bundleBuildStatus, styles.error)} data-testid="diag-bundle-error">
          <ErrorIcon className={styles.iconSize} />
          <span>{bundleRebuildError}</span>
        </div>
      )}

      {isBuilding && (
        <div className={clsx(styles.bundleBuildStatus, styles.building)} data-testid="diag-bundle-building">
          <CircularProgress size={16} />
          <span>{localizeMessage('operator.diag.bundle.building')}</span>
        </div>
      )}
    </div>
  );
}

BundleBuildBlock.propTypes = {
  bundleRebuildStatus: PropTypes.oneOf([null, 'queued', 'running', 'success', 'failed']),
  bundleRebuildError: PropTypes.string,
  onRebuildBundle: PropTypes.func,
  onBuildAndPromote: PropTypes.func,
};

BundleBuildBlock.defaultProps = {
  bundleRebuildStatus: null,
  bundleRebuildError: null,
  onRebuildBundle: null,
  onBuildAndPromote: null,
};

export default BundleBuildBlock;
